import { useContext, useMemo } from "react";
import { isEmpty } from "lodash";
import { motion } from "framer-motion";
import { Text } from "@mantine/core";

import type { Message } from "wall/types/message.model";
import { config } from "config";
import { getImageUrl } from "common/utils/getImageUrl";
import { WallContext } from "wall/hooks/useWall";
import { DEFAULT_WHITE_COLOR } from "../../../../_graphic_design";

function AnimatedMessage({ message }: { message: Message }) {
  const wall = useContext(WallContext);

  const styles = useMemo(
    () =>
      !isEmpty(wall) && wall.colors
        ? {
            message: {
              color: wall.colors.messages,
              fontSize: wall.msgFontSize || "110px",
              lineHeight: wall.msgLineHeight || "130px",
            },
            author: {
              color: wall.colors.authors,
              fontSize: wall.msgAuthorFontSize || "80px",
            },
          }
        : {
            message: {
              color: DEFAULT_WHITE_COLOR,
              fontSize: "110px",
              lineHeight: "130px",
            },
            author: { color: DEFAULT_WHITE_COLOR, fontSize: "80px" },
          },
    [wall],
  );

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      style={{ width: "1610px" }}
      className={`flex gap-3 items-center ${wall.slideShowStructure === "left-photo" ? "flex-row-reverse" : "flex-row"}`}
    >
      <div className={"w-[870px]"}>
        <Text
          className={` mb-3 font-marfa break-words whitespace-normal ${wall?.isMsgBold && "font-bold"}`}
          sx={styles.message}
        >
          {wall?.isMsgUppercase
            ? message.message
                .substring(0, config.walls.maxMessageSize)
                .toUpperCase()
            : message.message.substring(0, config.walls.maxMessageSize)}
        </Text>
        <Text
          className={`text-left font-marfa ${wall?.isAuthorBold && "font-bold"}`}
          sx={styles.author}
        >
          {wall?.isAuthorUppercase
            ? message.author.toUpperCase()
            : message.author}
        </Text>
      </div>

      {message.imageKey && (
        <div className="w-[640px] h-[calc(100vh-50px)] mx-[50px] rounded-2xl overflow-hidden flex items-center justify-center">
          <img
            className="rounded-2xl"
            style={{
              objectFit: "cover",
              objectPosition: "center center",
              width: "100%",
              height: "100%",
              maxWidth: "none",
              maxHeight: "none",
            }}
            src={getImageUrl(message.imageKey)}
            alt="Non trouvée"
          />
        </div>
      )}
    </motion.div>
  );
}

export default AnimatedMessage;
